<template>
  <v-container>
    <v-layout justify-center align-start v-if="Object.keys(data).length === 0" class="printNone pa-5">
      <v-flex xl2 md4 sm6 xs12>
        <v-card class="br-10 pa-4 text-center">
          <div class="title pa-3">{{ $t('searching') }}</div>
          <v-layout row wrap pt-2 justify-center class="pa-5">
            <v-btn :block="$vuetify.breakpoint.xsOnly" color="primary" class="white--text" rounded type="button" large @click="$router.push('/'); resetData()">{{ $t('go_to_homepage') }}</v-btn>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout v-if="Object.keys(data).length !== 0" row wrap :column="$vuetify.breakpoint.xsOnly" class="pa-5">
      <v-layout id="printLayout" justify-center row wrap>
        <v-layout row style="text-align: center; margin-top: 5em;" class="printShow">
          <v-layout column style="margin-right: -2em;">
            <!-- <span><img src="img/mpt.gif" alt="MPT Logo" height="65" width="62"></span> -->
            <span>MAJLIS PERBANDARAN TAWAU</span>
            <span>Peti Surat 412, Jalan Dunlop, 91007 Tawau, Sabah</span>
            <span>Tel: 089-701698, Fax: 089-701631</span>
          </v-layout>
          <qrcode-vue :value="url" size="80" level="H" style="text-align: right; margin-top: -6em;"></qrcode-vue>
        </v-layout>
        <v-flex xs12 sm6 class="property_info">
          <h3 class="printShow" style="padding: 10px;">{{ $t('page_license.info2') }}</h3>
          <hr class="printShow">
          <v-list two-line class="display-flex" dense>
            <v-subheader class="printNone"><h3>{{ $t('page_license.info2') }}</h3></v-subheader>
            <v-divider class="printNone"/>
            <v-list-item class="width33">
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-bookmark fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="body-2">{{ data.no_lesen }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('page_license.license_no2') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="width33">
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-list fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="body-2">{{ $t(data.m_kod_type) | uppercase }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('page_license.index.m_kod_type2') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="width33">
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-info-circle fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="body-2">{{ $t(`page_license.${data.statusl}`) | uppercase }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('page_license.status') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-list three-line dense>
            <v-list-item>
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-building fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="body-2 ellipsis">{{ data.nama_s !== '-' ? hideText(data.nama_s) : "-" }}</v-list-item-title>
                <v-list-item-subtitle class="body-2" style="padding-bottom: 10px">{{ $t('page_license.company_name') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-flag fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="body-2 ellipsis">{{ data.jniaga_s }}</v-list-item-title>
                <v-list-item-subtitle class="body-2" style="padding-bottom: 10px">{{ $t('page_license.jniaga_s') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-gavel fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="body-2 ellipsis">{{ data.kod_j_niaga | uppercase }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('page_license.kod_j_niaga') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-map-marker fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <textarea :value="data.lokasi" style="width: 100%" class="printNone " disabled/>
                <span class="printShow">{{ data.lokasi | uppercase }}</span>
                <v-list-item-subtitle class="body-2">{{ $t('page_license.location') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <h3 class="printShow" style="padding: 10px;">{{ $t('page_license.owner_info') }}</h3>
            <hr class="printShow">
          </v-list>
          <br class="printNone">
          <v-subheader class="printNone" style="background-color: white;"><h3>{{ $t('page_license.owner_info') }}</h3></v-subheader>
          <v-list v-for="item in data.owner_license" :key="item._id" two-line class="display-flex">
            <v-divider class="printNone" style=" margin-top: -10px"/>
            <v-list-item class="width33">
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-user-circle fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="body-2 ellipsis">{{ hideText(item.owner_name || item.organization_name) }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('page_license.name') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="width33">
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-id-card fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="body-2">{{ hideIC(item.new_ic) || item.registered_no }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ item.pemilikan }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-flex>
        <v-flex xs12 sm6 :pt-3="$vuetify.breakpoint.xsOnly">
          <v-layout column :pl-3="$vuetify.breakpoint.smAndUp">
          <h3 class="printShow" style="padding: 10px;">{{ $t('page_assessment.previous_payment_info') }}</h3>
          <hr class="printShow">
          <v-list two-line class="display-flex" dense>
            <v-subheader class="printNone"><h3>{{ $t('page_assessment.previous_payment_info') }}</h3></v-subheader>
            <v-divider class="printNone"/>
            <v-list-item class="width33">
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-calendar fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="body-2">{{ lastPaymentDate(data) }}</v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ $t('page_assessment.last_payment_date') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="width33">
              <v-list-item-action class="printNone">
                <v-icon color="primary lighten-2" class="pl-2">fa-bookmark fa-lg</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-card class="body-2 elevation-0">{{ data.no_resit }}</v-card>
                <v-list-item-subtitle class="body-2">{{ $t('page_assessment.receipt_no_last_received') }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <br class="printNone">
          <v-list two-line class="display-flex" dense>
            <v-subheader class="printNone"><h3>{{ $t('page_license.payment_info') }}</h3></v-subheader>
            <v-divider class="printNone"/>
          </v-list>
            <h3 class="printShow" style="padding: 10px;">{{ $t('page_license.payment_info') }}</h3>
            <hr class="printShow">
            <v-list three-line class="display-flex marginBottom40"  dense>
              <v-list-item class="width50">
                <v-list-item-action class="printNone">
                  <v-icon color="primary lighten-2" class="pl-2">fa-credit-card fa-lg</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-card class="title elevation-0"><strong>{{ data.full_payment | currency('RM ') }}</strong></v-card>
                  <v-list-item-subtitle class="body-2"><strong>{{ $t('amount_to_be_paid') + $t('service_charge_included') }}</strong></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <span class="text-center caption printShow pt-4">*Slip ini merupakan salinan tidak rasmi untuk rujukan peribadi sahaja.*</span>
            <span class="text-center caption printShow">Tarikh: {{ new Date().toLocaleString('en-GB') }}, Dicetak oleh: {{ username + ' @ App e-Services MPT' }} </span>
            <v-layout mt-2 class="printNone column">
              <div :class="$vuetify.breakpoint.xsOnly ? 'column' : 'row justify-end'">
                <v-col>
                  <v-btn block color="teal" class="white--text" large rounded @click="redirect('renewal')" :disabled="data.statusl !== 'active' && data.statusl !== 'expired' || inProgress()">{{ $t('page_license.renewal') }}</v-btn>
                </v-col>
                <v-col>
                  <v-btn block color="primary" class="white--text" large rounded @click="print(data)">{{ $t('print_page') }}</v-btn>
                </v-col>
                <v-col v-if="!hasSession">
                  <v-btn block color="orange" class="white--text" large rounded @click="setLoginVisible({ visible: true })">{{ $t('login_to_print_license') }}</v-btn>
                </v-col>
                <v-col v-if="hasSession">
                  <v-btn block color="blue" class="white--text" large rounded @click="redirect('mptpay-history')">{{ $t('payment_history_mptpay') }}</v-btn>
                </v-col>
              </div>
              <div class="text-center pt-3 pb-3 error white--text br-10 px-1" v-if="inProgress() && Object.keys(lastPayment).length > 0">
                <span v-if="lastPayment.status === 'in_progress'">{{ $t('payment_alert_progress', { type: $t(data.type).toLowerCase(), account: data._id, date: new Date (lastPayment.payment_datetime).toLocaleDateString('en-GB') }) }}</span>
                <span v-if="lastPayment.status === 'successful'">{{ $t('payment_alert_success', { type: $t(data.type).toLowerCase(), account: data._id, date: new Date (lastPayment.success_timestamp).toLocaleDateString('en-GB') }) }}</span>
              </div><br/>

              <span class="text-h6 font-weight-bold">{{ $t('attention') }}:</span>
              <ul class="a">
                <li><span class="text-body2 font-weight-medium">{{ $t('reprint1') }}</span></li>
                <li><span class="text-body2 font-weight-medium">{{ $t('reprint2') }}</span></li>
                <li><span class="text-body2 font-weight-medium">{{ $t('reprint3') }}</span></li>
              </ul>
            </v-layout>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import vuex from 'vuex'
import QrcodeVue from 'qrcode.vue'
import configuration from '../../configurations/index'

export default {
  async beforeMount () {
    await this.fetchData({ id: atob(this.$route.params.id), type: `license_trading` })
  },
  async beforeRouteUpdate (to, from, next) {
    await this.resetData()
    next()
  },
  components: {
    QrcodeVue
  },
  computed: {
    ...vuex.mapGetters({
      hasSession: 'auth/hasSession'
    }),
    ...vuex.mapState({
      data: state => state.search.data,
      dbLastUpdated: state => state.search.dbLastUpdated,
      lastPayment: state => state.search.lastPayment,
      username: state => state.auth.username
    })
  },
  data () {
    return {
      url: 'http://services.mptpay.net/' + window.location.hash
    }
  },
  methods: {
    ...vuex.mapActions({
      fetchData: 'search/fetchData'
    }),
    ...vuex.mapMutations({
      setLoginVisible: 'dialog/setLoginVisible',
      resetData: 'search/resetData'
    }),
    hideIC: function (text) {
      var t = text || ''
      var hiddenText = ''
      if (t.length !== 0) {
        for (var i = 0; i < t.length; i++) {
          if (i < t.length - 4) {
            hiddenText += '*'
          } else {
            hiddenText += t[i]
          }
        }
      }
      return hiddenText
    },
    hideText (text) {
      var t = text || ''
      var hiddenText = ''
      for (var i = 0; i < t.length; i++) {
        if (i > 4) {
          hiddenText += '*'
        } else {
          hiddenText += t[i]
        }
      }
      return hiddenText
    },
    inProgress () {
      if (Object.keys(this.lastPayment).length < 1) return false
      const lastPay = this.lastPayment.services.filter(row => row.license_no === this.data._id)
      if (lastPay.length > 0) {
        return new Date(this.lastPayment.payment_datetime) >= this.dbLastUpdated
      }
      return false
    },
    lastPaymentDate (data) {
      var date = data.trk_akhir_bayar || ''
      if (date.length === 8) date = date.slice(6, 8) + '/' + date.slice(4, 6) + '/' + date.slice(0, 4)
      return date
    },
    payOnline (data) {
      if (!window.hasOwnProperty('cordova')) {
        window.location.href = `${configuration.host.epayment}/#/confirmation?_id=${
          btoa(data.lic_rujukan)
        }&council=mpt&payment_type=license_trading`
        return
      }
      let ref = cordova.InAppBrowser.open(`${configuration.host.epayment}/#/confirmation?_id=${
        btoa(data.lic_rujukan)
      }&council=mpt&payment_type=license_trading`, '_self', 'location=no,enableViewportScale=yes,zoom=no')
      let params = ''
      ref.addEventListener('loadstop', function (event) {
        if (event.url.substring(0, 41) === `${configuration.host.epayment}/#/receipt?`) {
          params = event.url.substring(41, event.url.length)
          ref.close()
          this.$router.push('/receipt?' + params)
        }
        if (event.url === `${configuration.host.epayment}/#/index.html#/` || event.url === `${configuration.host.epayment}/#/`) {
          ref.close()
          this.$router.push('/')
        }
      }.bind(this))
    },
    print (data) {
      if (!window.hasOwnProperty('cordova')) {
        window.print()
        return
      }
      document.getElementsByTagName('noscript')[0].parentNode.removeChild(document.getElementsByTagName('noscript')[0])
      var page = document.documentElement
      cordova.plugins.printer.print(page, `${data.no_lesen}.html`)
    },
    redirect (category) {
      let page
      if (category === 'renewal') {
        this.$router.push({ name: 'trading-renewal-id', id: btoa(this.data.lic_rujukan) })
      }
      if (category === 'mptpay-history') {
        page = `${configuration.host.epayment}/#/history`
        if (!window.hasOwnProperty('cordova')) {
          window.location.href = page
          return
        }
        cordova.InAppBrowser.open(page, '_system', 'location=no,enableViewportScale=yes,zoom=no')
      }
    }
  }
}
</script>

<style>
.br-10 {
  border-radius: 10px;
}

.ellipsis {
  white-space: nowrap;
  width: 250px;
  text-overflow: ellipsis;
}

#councilInfo,
.printShow {
  display: none;
}

@media print {
  .v-app-bar {
    display: none;
  }
  #councilInfo,
  #councilInfo span {
    display: block;
    text-align: center;
  }
  #printLayout {
    margin-top: -110px;
  }
  .property_info {
    max-width: 400px;
  }
  .display-flex {
    display: flex;
  }
  .printShow {
    display: block;
  }
  .printNone {
    display: none;
  }
  .pageBreak {
    page-break-after: always;
  }
  .width25 {
    width: 25% !important;
  }
  .width33 {
    width: 33% !important;
  }
  .width50 {
    width: 50% !important;
  }
  .marginBottom40 {
    margin-bottom: -40px;
  }
}
</style>
